
import DeleteSnippetModal from '@/components/finagent/DeleteSnippetModal';
import EditSnippetTitleModal from '@/components/finagent/EditSnippetTitleModal';
import SnippetCard from '@/components/marketAnalysis/SnippetCard';
import { backendExceptionHandler } from "@/mixins";
import FinAgentService from '@/service/FinAgentService';
import FormatterService from '@/service/FormatterService';
import _ from 'lodash';

const PAGE_SIZE = 6;
export default {
    name: 'SnippetsLibraryContainer',

    components: {
        SnippetCard,
        EditSnippetTitleModal,
        DeleteSnippetModal,
    },

    mixins: [backendExceptionHandler],

    emits: ['update-snippet-details-title'],

    data() {
        return {
            searchText: '',
            isLoading: true,
            snippets: [],
            errorMessage: '',
            currentPage: 1,
            selectedSnippet: null,
            isLoadingSnippetDetails: false,
            snippetToEdit: null,
            isEditSnippetModalVisible: false,
            snippetToDelete: null,
            isDeleteSnippetModalVisible: false,
        }
    },

    computed: {
        searchIcon() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/search-dark.svg') :
                require('@/assets/icons/search-light.svg')
        },
        deleteIcon() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/delete-dark.svg') :
                require('@/assets/icons/delete-light.svg');
        },
        noDataIcon() {
            return this.$vuetify.theme.dark ?
                require('@/assets/icons/no-snippet-dark.svg') :
                require('@/assets/icons/no-snippet-light.svg');
        },
        showNoData() {
            return !this.isLoading && !this.displayedSnippets.length;
        },
        totalPages() {
            return Math.ceil(this.snippets.length / PAGE_SIZE);
        },
        displayedSnippets() {
            if (!this.snippets.length) {
                return [];
            }

            const clonedData = _.cloneDeep(this.snippets);
            const pageToCalculate = this.currentPage - 1;
            return clonedData.slice(pageToCalculate * PAGE_SIZE, (pageToCalculate + 1) * PAGE_SIZE);
        }
    },

    watch: {
        searchText() {
            this.currentPage = 1;
            this.fetchSnippets();
        },
        selectedSnippet(data) {
            if (data && data.title) {
                this.$emit('update-snippet-details-title', data.title);
            }
        }
    },

    created() {
        this.format = new FormatterService();
        this.finAgentService = new FinAgentService(this.$axios);
        this.fetchSnippets();
        this.debouncedChangeSearchText = _.debounce((value) => {            
            this.searchText = value;
        }, 300)
    },

    beforeDestroy() {
        this.cancelActiveSearchRequest();
        this.cancelActiveSnippetDetailsRequest();
    },

    methods: {
        cancelActiveSearchRequest() {
            if (this.activeSearchRequest) {
                this.activeSearchRequest.cancel();
            }
        },

        cancelActiveSnippetDetailsRequest() {
            if (this.activeSnippetDetailsRequest) {
                this.activeSnippetDetailsRequest.cancel();
            }
        },

        async fetchSnippets() {
            this.cancelActiveSearchRequest();
            this.isLoading = true;
            const axiosSource = this.$axios.CancelToken.source();
            this.activeSearchRequest = { cancel: axiosSource.cancel, msg: "Cancel fetching snippets..." };

            try {
                const data = await this.finAgentService.getSnippets(this.searchText, { axiosSource });
                this.activeSearchRequest = null;
                this.snippets = data || [];
                this.isLoading = false;
            } catch (error) {
                if (this.$axios.isCancel(error)) {
                    return;
                }
                this.isLoading = false;
                this.activeSearchRequest = null;
                this.snippets = [];
                this.handleBackendException(error, this.$t('common.errors.generalError'));
                this.$store.commit('snackbar/updateType', 'error');
                this.$store.commit('snackbar/updateMessage', this.errorMessage);
            }
        },

        handleClickEditSnippet(data) {
            this.snippetToEdit = data;
            this.isEditSnippetModalVisible = true;
        },

        handleClickDeleteSnippet(data) {
            this.snippetToDelete = data;
            this.isDeleteSnippetModalVisible = true;
        },

        handleEditSnippetSuccess(data) {
            this.snippetToEdit = null;
            const snippetIndex= this.snippets.findIndex(s => s.id === data.id);
            if (snippetIndex > -1) {
                this.$set(this.snippets[snippetIndex], 'title', data.newTitle);
            }
        },

        handlDeleteSnippetSuccess(ids = []) {
            const deletedId = ids[0];
            this.snippetToDelete = null;
            this.snippets = this.snippets.filter(s => s.id !== deletedId);
        },
    }
}
